import {FirebaseApp, getApps, initializeApp} from 'firebase/app';
import {configuration} from '../config';

const firebaseOptions =
  configuration?.firebase && Object.keys(configuration.firebase).length > 0
    ? configuration.firebase
    : {apiKey: 'mock-api-key', appId: 'mock-app-id', projectId: 'mock-project-id'};

export function getOrInitializeFirebaseApp(): FirebaseApp {
  const apps = getApps();
  return apps.length > 0 ? apps[0] : initializeApp(firebaseOptions);
}

export const firebaseApp: FirebaseApp = getOrInitializeFirebaseApp();
